<template>
  <div id="container">
    <div class="box_one" > 
      <cont-top/>
    </div>     
    <div class="main" style="margin-bottom:5px"> 

      <div class="title">
        <div class="title_name"></div>
      </div>

      <div class="clear" style="padding: 0 40px"> 
        <div style="width:203px;float:right;margin-left:70px">
          <el-image
            style="width:202px; margin-bottom:20px"
            :src="require('@/assets/image/brand/BrandJp/img3.png')"
            fit="fit">
          </el-image>
          <el-image
            style="width:202px; margin-bottom:20px"
            :src="require('@/assets/image/brand/BrandJp/img4.png')"
            fit="fit">
          </el-image>
        </div>  


        <div style="font-size:18px">
          <div style="margin-bottom:20px;text-indent:32px">
            公司创业以来一直不断追求2个【Satisfaction】（顾客满足/CS）。毋庸置疑，为了更好的实现CS，还需要另个一【Satisfaction】，那就是【Employee Satisfaction】（员工满足/ES）。
          </div>

 

          <div style="margin-bottom:20px;text-indent:32px">
            创业15周年的2018年夏天，敝社在公司发源地大阪府摄津市设立的新公司大楼以求向着次世代迈进。之前的开发、制造、物流、营业等职能部门都分散在各处。
          </div>

          <div style="margin-bottom:20px;text-indent:32px">
            今后所有部门将集中在一处工作，这将大大改善商品的开发、最短供货的生产体制、物流成本的消减等，客户的满足度也将大大提升。同时，为了实现大幅提升员工的满足度，我们也构筑了更为牢固的基盘。为了长久维持客户满意度，让自己的员工时刻感到满意也不可或缺。          
          </div>

          <div style="margin-bottom:20px;text-indent:32px">
            干练的员工能提供高品质的服务，只有熟练的操作才能成就最高级的品质，说顾客的高满足度来源于公司员工的强烈意识和丰富的经验也不为过。员工的满足度上升成就了客户的满足度上升，结果就是业绩越来越好，所以我确信大家会朝着让客户更加满意的良性循环而更为努力。
          </div>

          <div style="margin-bottom:20px;text-indent:32px">
            无论是过去还是现在，或是将来，敝社将一直追求这两个【Satisfaction】。为了使“刹车品牌DIXCEL”变为“说到刹车就能想到DIXCEL”，我们将继续竭尽全力为客户服务。
          </div>
        </div>



      </div>

    </div>    
    <div class="box_bottom" > 
      <cont-bottom/>
    </div>
  </div>
</template>

<script>
import ContTop from './Cont_top'
import ContBottom from '@/views/Components/Cont_bottom'


export default {
  data() {
    return {
      fit : 'contain'
    }
  },
  components : {
    ContTop ,
    ContBottom ,
  }
}

</script>

<style lang="stylus" scoped>
.clear:after {
  display: block;
  clear: both;
  content: '';
}

#container
  background-color : #000
  .box_one 
    width: 100%;
    // background: url("~@/assets/image/brand/img1.png");
    background-repeat : no-repeat 
    background-size : cover
    background-color #000

  .box_bottom
    width: 100%;
    background-color #000


.main {
  margin-bottom: 5px;
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  padding: 55px 0 44px
}

.title {
  position: absolute;
  width: 170px;
  height: 108px;
  left: 66px;
  top: -68px;
  background: url('~@/assets/image/brand/BrandJp/img1.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 33px 33px 16px 40px; 
  box-sizing: border-box;
}

.title_name {
  width: 97px;
  height: 59px;
  background: url('~@/assets/image/brand/BrandJp/img2.png');
  background-repeat: no-repeat;
  background-size: contain;
}

</style>